import { render, staticRenderFns } from "./CoverageButtons.vue?vue&type=template&id=189863ae&scoped=true&"
import script from "./CoverageButtons.vue?vue&type=script&lang=js&"
export * from "./CoverageButtons.vue?vue&type=script&lang=js&"
import style0 from "./CoverageButtons.vue?vue&type=style&index=0&id=189863ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189863ae",
  null
  
)

export default component.exports